module.exports = __webpack_public_path__ + "img/info3.d308906d.png";